import { TGetIdea } from "src/components/ideaHub/ideaHub.types";
import cx from './ideadetail.module.scss';
import GradientButton from "src/components/common/formFields/gradient-button/GradientButton";
import { useNavigate } from "react-router-dom";

export default function IdeaDetail({ viewIdea: ideaData }: { viewIdea: TGetIdea | null }) {
    const idea = ideaData?.idea;
    const navigate = useNavigate();
    // Helper function to check if field has meaningful data
    const hasValidData = (value: string | null | undefined) => {
        return !!value;
    };

    // Helper function to get display value or fallback
    const getDisplayValue = (value: string | null | undefined, fallback: string = 'Not specified') => {
        return hasValidData(value) ? value : fallback;
    };

    // Helper function to render section only if data exists
    const renderSection = (title: string, content: string | null | undefined) => {
        if (!hasValidData(content)) return null;

        return (
            <div className={cx.card}>
                <h2>{title}</h2>
                <p>{content}</p>
            </div>
        );
    };

    // Helper function to render competitors section
    const renderCompetitorsSection = () => {
        if (!hasValidData(idea?.competitors)) return null;

        // Try to parse competitors as a list if they contain line breaks or numbers
        const competitorsText = idea?.competitors || '';
        const competitorsList = competitorsText.split('\n').filter(item => item.trim());

        if (competitorsList.length > 1) {
            return (
                <div className={cx.card}>
                    <h2>Competitors</h2>
                    <div>
                        {competitorsList.map((competitor, index) => (
                            <p key={index} style={{ marginBottom: '4px' }}>
                                {competitor.trim().startsWith(`${index + 1}.`)
                                    ? competitor.trim()
                                    : `${index + 1}. ${competitor.trim()}`
                                }
                            </p>
                        ))}
                    </div>
                </div>
            );
        } else {
            return renderSection("Competitors", competitorsText);
        }
    };

    return (
        <section className={cx.section}>
            {/* Idea Title - Always show, with fallback */}
            <div className={cx.card}>
                <h2>Idea Title</h2>
                <p>{getDisplayValue(idea?.title, 'Untitled Idea')}</p>
            </div>

            {/* Domain */}
            {renderSection("Idea Domain", idea?.domain)}

            {/* Problem Statement */}
            {renderSection("Problem Statement", idea?.identifiedProblem)}

            {/* Solution */}
            {renderSection("Solution", idea?.solutionEffectiveness)}

            {/* USP (Unique Value Proposition) */}
            {renderSection("USP", idea?.uniqueValueProposition)}

            {/* Business Model (Revenue Stream) */}
            {renderSection("Business Model", idea?.majorRevenueStream)}

            {/* Competitors */}
            {renderCompetitorsSection()}

            {/* Target Audience */}
            {renderSection("Target Audience", idea?.targetAudience)}

            {/* Owner Information */}
            {idea?.owner?.name && (
                <div className={cx.card}>
                    <h2>Idea Owner</h2>
                    <p>{idea?.owner?.name || 'Unknown'}</p>
                </div>
            )}
            <div className={cx.buttonContainer}>
                <GradientButton onClick={() => navigate(`/idea-hub?id=${idea?.id}`)}>
                    Update & Validate with AI
                </GradientButton>
            </div>
        </section>
    );
}
